import { featureFlags } from '@config/featureFlags';
import { useCurrentUser } from '@hooks/useCurrentUser';

/**
 * Whether the helpable-at-live-event surfaces (the "For you" section, the
 * live-pill count chip, and the feed chips) are enabled for the current viewer.
 *
 * The SINGLE gate read path for all three surfaces AND their shared fetch
 * (`useEventHelpable`), so the public flip stays a one-line flag change. EXACTLY
 * mirrors `useInvitePromptsEnabled` / `useHelperFeedEnabled`: the feature ships
 * dark behind `featureFlags.helpableAtEvent` for everyone EXCEPT Meetball
 * platform admins (`has_extra_options`), who see it in production for dogfooding
 * ("always on for admins", regardless of any other flag). Same admin-gating
 * precedent as `suggestedHelpers` (`QuestionDetails.tsx`) and the server-controlled
 * admin flag `AdminRoute` gates on.
 *
 * Returns:
 *  - `true` for admins regardless of the flag (surfaces fully ON: section,
 *    pill chip, feed chips, and the fetch behind them).
 *  - `featureFlags.helpableAtEvent` otherwise, so non-admins stay fully DARK
 *    while the flag is off, and the surfaces launch for everyone when it flips on.
 */
export function useHelpableAtEventEnabled(): boolean {
  const { user } = useCurrentUser();
  return Boolean(user?.has_extra_options) || featureFlags.helpableAtEvent;
}
